import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import ButtonPanel from '../../ButtonPanel'
import { saveWidthdrawRequestProgress } from '../../../redux/actions/withdrawRequest'
import WithdrawRequestWithProgressForm from './WithdrawRequestWithProgressForm'
import WithdrawRequestWithProgressView from './WithdrawRequestWithProgressView'

export default function WithdrawRequestWithProgressWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isInitial, onSuccess } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors, getValues } = useForm()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(_schema)
  const [requestId, setRequestId] = useState('')

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    setFormSchema(_schema)
    console.log(_schema)
  }, [_schema])

  useEffect(() => {
    if (isInitial) {
      setIsEdit(true)
    }
  }, [isInitial])

  useEffect(() => {
    if (!showCommandButton) {
      setIsEdit(false)
    }
  }, [showCommandButton])

  useEffect(() => {
    // let requestId = location.search.substring(1)
    let requestId = sessionStorage.getItem('param')?.substring(1)
    // console.log('WithdrawRequestWidget', 'request_id: ', requestId)
    if (requestId) {
      setRequestId(requestId)
    }
  }, [location.search])

  const handleSave = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError()
    try {
      const response = await saveWidthdrawRequestProgress(projectId, requestId, request)

      console.log('response', response)

      if (response) {
        setFormSchema(response)
        setIsEdit(!isEdit)
      }
    } catch (e) {
      console.log('error', e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('submit data', data)

    let dataIsBuyingMaterial = 0
    console.log('length data => ', data?.isBuyingMaterial)

    if (data?.isBuyingMaterial?.length == 1) {
      console.log('length == 1')
      dataIsBuyingMaterial = data?.isBuyingMaterial.toString()
    } else if (data?.isBuyingMaterial?.length == 2) {
      console.log('length == 2')
      dataIsBuyingMaterial = 3
    }

    // console.log('dataIsBuyingMaterial => ', dataIsBuyingMaterial)

    // return false

    const request = {
      isProblemEncountered: data.isProblemEncountered,
      problemDescription: data.problemDescription,
      isRiskEvaluationOfManagement: data.isRiskEvaluationOfManagement,
      riskEvaluationOfManagementDescription: data.riskEvaluationOfManagementDescription,
      isRiskEvaluationOfFinace: data.isRiskEvaluationOfFinace,
      riskEvaluationOfFinaceDescription: data.riskEvaluationOfFinaceDescription,
      levelOfInteresting: data.levelOfInteresting || 0,
      interestingDescription: data.interestingDescription,
      isBudgetRemain: data.isBudgetRemain,
      tarnferFromProjectCode: data.projectCodeInputMore,
      budgetRemainOrOver: data.budgetRemainOrOver || 0,
      opinionOfCoordinator: data.opinionOfCoordinator,
      // isBuyingMaterial: data.isBuyingMaterial,
      isBuyingMaterial: dataIsBuyingMaterial,
      isProgress: data.isProgress,
      progressDescription: data.progressDescription,
      percentOfProgress: data.percentOfProgress || 0,
      percentOfActualOutcome: data.percentOfActualOutcome || 0,
      coordinatorCommentType: data.coordinatorCommentType || 1,
      otherComment: data.otherComment,
    }

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: '1em' }}
      ref={(section) => {
        setSection(section)
      }}
    >
      {isEdit ? (
        <WithdrawRequestWithProgressForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      ) : (
        <WithdrawRequestWithProgressView schema={formSchema} />
      )}

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              setIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              setIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
